import { render } from "./StakeItem.vue?vue&type=template&id=52119f18&scoped=true&ts=true"
import script from "./StakeItem.vue?vue&type=script&lang=ts"
export * from "./StakeItem.vue?vue&type=script&lang=ts"

import "./StakeItem.vue?vue&type=style&index=0&id=52119f18&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52119f18"]])

export default __exports__